import {
  ProductDetailsNutritionEntriesDivider,
  ProductDetailsNutritionEntriesItem,
  ProductDetailsNutritionEntriesList,
} from './components';

export const ProductDetailsNutritionEntries = {
  List: ProductDetailsNutritionEntriesList,
  Item: ProductDetailsNutritionEntriesItem,
  Divider: ProductDetailsNutritionEntriesDivider,
};
